import Header from './components/header/Header';
import Dashboard from './components/dashboard/Dashboard';
import LiveTimeline from './components/dashboard/timeline/LiveTimeline';
import Footer from './components/footer/Footer';
import GenericSimulatorProvider from './providers/GenericSimulatorProvider';
import GenericSimulatorConsole from './components/console/GenericSimulatorConsole';
import './GenericSimulatorDashboard.scss';
import SocketProvider from './providers/SocketProvider';
import useDeploymentDetails from './hooks/useDeploymentDetails';

/** Fetches deployment details on mount (both summary & running) */
const InitDataLoader = ({ children }: { children: React.ReactNode }) => {
    useDeploymentDetails();
    return <>{children}</>;
};

const GenericSimulatorDashboard = () => {
    return (
        <GenericSimulatorProvider>
            <InitDataLoader>
                <SocketProvider>
                    <div className='gs__dashboard__wrapper'>
                        <Header />
                        <Dashboard />
                        <LiveTimeline />
                        <Footer />
                        <GenericSimulatorConsole />
                    </div>
                </SocketProvider>
            </InitDataLoader>
        </GenericSimulatorProvider>
    );
};

export default GenericSimulatorDashboard;
